const release = '0.13.3'

module.exports = { release }



// WEBPACK FOOTER //
// ./release.js